import { useState } from "react";
import Header from "../Header/Header";
import "./Contact.css";

// NOTE: This form posts to Formspree (https://formspree.io), a free service
// for handling form submissions on static sites (no backend needed).
// 1. Go to formspree.io, sign up free, create a new form.
// 2. Copy the endpoint it gives you (looks like https://formspree.io/f/xxxxxxx)
// 3. Paste it into FORM_ENDPOINT below.
const FORM_ENDPOINT = "https://formspree.io/f/mqerrvdl";

const CONTACT_EMAIL = "batesk3rpi@gmail.com"; // <-- replace with your real email

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(e.target),
      });

      if (response.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <div className="contact-page">
      <Header />

      <main className="contact-container">
        <section className="contact-intro">
          <h1>Get In Touch</h1>
          <p>
            I'm always happy to connect about software engineering roles,
            projects, or just to chat. Reach out through the form below or
            find me on one of the links.
          </p>
        </section>

        <div className="contact-content">
          <div className="contact-links">
            <a
              className="contact-link-card"
              href={`mailto:${CONTACT_EMAIL}`}
            >
              <svg
                className="contact-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="M2 6l10 7 10-7" />
              </svg>
              <div>
                <h3>Email</h3>
                <p>{CONTACT_EMAIL}</p>
              </div>
            </a>

            <a
              className="contact-link-card"
              href="https://www.linkedin.com/in/katie-bates-679638250/" 
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-original.svg"
                alt=""
                className="contact-icon"
              />
              <div>
                <h3>LinkedIn</h3>
                <p>Connect with me</p>
              </div>
            </a>

            <a
              className="contact-link-card"
              href="https://github.com/himekatie"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg"
                alt=""
                className="contact-icon"
              />
              <div>
                <h3>GitHub</h3>
                <p>@himekatie</p>
              </div>
            </a>

            <a
              className="contact-link-card"
              href="/Katie_Bates_Resume.pdf"
              download
            >
              <svg
                className="contact-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <path d="M14 2v6h6" />
                <path d="M12 18v-6" />
                <path d="M9 15l3 3 3-3" />
              </svg>
              <div>
                <h3>Resume</h3>
                <p>Download PDF</p>
              </div>
            </a>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <label htmlFor="name">Name</label>
            <input
              id="name"
              name="name"
              type="text"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <label htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows="6"
              value={formData.message}
              onChange={handleChange}
              required
            />

            <button type="submit" disabled={status === "sending"}>
              {status === "sending" ? "Sending..." : "Send Message"}
            </button>

            {status === "success" && (
              <p className="form-status success">
                Thanks for reaching out! I'll get back to you soon.
              </p>
            )}
            {status === "error" && (
              <p className="form-status error">
                Something went wrong. Please try emailing me directly.
              </p>
            )}
          </form>
        </div>
      </main>
    </div>
  );
}

export default Contact;